export const ACTIVE = "ACTIVE"
export const INACTIVE = "INACTIVE"
export const EMAIL = "CONTA_EMAIL"
export const FEBRABAN = "CONTA_FEBRABAN"
export const MAIL = "CONTA_CORREIO"
export const NOT_SUPPORTED = "NOT_SUPPORTED"
export const MAIN = "MAIN"
export const SECONDARY = "SECONDARY"
export const SMS = "SMS"
export const E_MAIL = "EMAIL"
export const AUDIO = "AUDIO"
export const MENSAGEM_DE_AUDIO = "MENSAGEM DE AUDIO"
export const AUDIO_MESSAGE = "AUDIO_MESSAGE"

export const CUSTOMER_UPDATE_EXPIRATION = 60
export const USER_UPDATE_EXPIRATION = 6

const SendTypeTranslations = {
  [EMAIL]: "MSG_0022",
  [MAIL]: "MSG_0071",
  [FEBRABAN]: "MSG_0070"
}

export const SendTypes = {
  ONLINE_ACCOUNT: EMAIL,
  CONTA_EMAIL: EMAIL,
  FEBRABAN_ACCOUNT: FEBRABAN,
  CONTA_FEBRABAN: FEBRABAN,
  CONTA_CORREIO: MAIL,
  DOWNLOAD_DE_CONTA: FEBRABAN,
  BRAILLE_ACCOUNT: MAIL,
  EXTENDED_SOURCE_ACCOUNT: MAIL,
  NONE: MAIL,
  NOT_SUPPORTED: MAIL,
  CONTA_BRAILE: MAIL,
  CONTA_FONTE_AMPLIADA: MAIL
}

export const SendType = {
  translationKey: (key) => SendTypeTranslations[SendTypes[key]]
}

export const ContactPreferences = {
  // Para pessoa física:
  1: "Esposo(a)",
  2: "Filho(a)",
  3: "Mãe",
  4: "Pai",
  5: "Usuário do Serviço",
  6: "Próprio Cliente",
  // Para pessoa juridica:
  7: "Sócio Proprietário",
  8: "Presidente",
  9: "Vice Presidente",
  10: "Diretor Executivo",
  11: "Comercial",
  12: "Financeiro",
  13: "Técnico",
  14: "Secretária",
  15: "Tecnologia",
  16: "Administrador Domínio",
  23: "E-mail para Pesquisa"
}

export const NotificationMethod = [
  {
    label: "E-mail",
    value: "1"
  },
  {
    label: "Telefone",
    value: "2"
  }
]

export const SendingType = [
  {
    label: "E-mail",
    value: "EMAIL",
    displayValue: "E-MAIL"
  },
  {
    label: "SMS",
    value: "SMS",
    displayValue: "SMS"
  },
  {
    label: "Mensagem por áudio",
    value: "MENSAGEM DE AUDIO",
    displayValue: "MENSAGEM DE AUDIO"
  },
  {
    label: "Notificação push",
    value: "PUSH",
    displayValue: "PUSH"
  }
]

export const Genders = [
  {
    label: "Feminino",
    value: "1"
  },
  {
    label: "Masculino",
    value: "2"
  }
]

export const CustomerStatus = {
  ATIVO: "ACTIVE",
  S: "ACTIVE",
  INATIVO: "INACTIVE",
  N: "INACTIVE",
  NOT_SUPPORTED: "NOT_SUPPORTED"
}

export const ContactType = {
  PRINCIPAL: MAIN,
  SECUNDARIO: SECONDARY,
  ROOT: "ROOT",
  NOT_SUPPORTED: "NOT_SUPPORTED"
}

export const ContactTypeInverse = {
  MAIN: "PRINCIPAL",
  SECONDARY: "SECUNDARIO",
  ROOT: "ROOT",
  NOT_SUPPORTED: "NOT_SUPPORTED"
}

export const CustomerSegment = {
  RESIDENCIAL: "RESIDENTIAL",
  EMPRESARIAL: "BUSINESS",
  CORPORATIVO: "CORPORATE",
  NOT_SUPPORTED: "NOT_SUPPORTED",
  COMMON: "COMMON"
}

export const CustomerType = {
  "PESSOA FISICA": "PERSON",
  "PESSOA JURIDICA": "COMPANY",
  "GOVERNO MUNICIPAL": "CITY_GOVERNMENT",
  "GOVERNO ESTADUAL": "STATE_GOVERNMENT",
  "GOVERNO FEDERAL/ECONOMIA MISTA": "FEDERAL_GOVERNMENT",
  "CLIENTE INTERNACIONAL": "INTERNATIONAL_GOVERNMENT",
  NOT_SUPPORTED: "NOT_SUPPORTED"
}

export const CustomerGender = {
  Masculino: "MALE",
  Feminino: "FEMALE",
  NOT_SUPPORTED: "NOT_SUPPORTED"
}

export const CitiesGedisa = [
  "AJURICABA",
  "ALECRIM",
  "ALEGRIA",
  "ALPESTRE",
  "ALTO FELIZ",
  "AMETISTA DO SUL",
  "ANDRE DA ROCHA",
  "ANTA GORDA",
  "ANTONIO PRADO",
  "ARATIBA",
  "ARVOREZINHA",
  "AUGUSTO PESTANA",
  "AUREA",
  "BARAO",
  "BARAO DE COTEGIPE",
  "BARRA DO GUARITA",
  "BARRA DO RIO AZUL",
  "BARRA FUNDA",
  "BARRACAO",
  "BARROS CASSAL",
  "BENJAMIN CONSTANT DO SUL",
  "BENTO GONCALVES",
  "BOA VISTA DAS MISSOES",
  "BOA VISTA DO BURICA",
  "BOA VISTA DO CADEADO",
  "BOA VISTA DO SUL",
  "BOM JESUS",
  "BOM PROGRESSO",
  "BOZANO",
  "BRAGA",
  "CACHOEIRINHA",
  "CACIQUE DOBLE",
  "CAICARA",
  "CAMARGO",
  "CAMBARA DO SUL",
  "CAMPESTRE DA SERRA",
  "CAMPINA DAS MISSOES",
  "CAMPINAS DO SUL",
  "CAMPO NOVO",
  "CANDIDO GODOI",
  "CANELA",
  "CAPAO BONITO DO SUL",
  "CARLOS BARBOSA",
  "CARLOS GOMES",
  "CASCA",
  "CASEIROS",
  "CATUIPE",
  "CAXIAS DO SUL",
  "CENTENARIO",
  "CERRO GRANDE",
  "CERRO LARGO",
  "CHARRUA",
  "CHIAPETA",
  "CIRIACO",
  "CONSTANTINA",
  "CORONEL BICACO",
  "CORONEL PILAR",
  "COTIPORA",
  "COXILHA",
  "CRISSIUMAL",
  "CRISTAL DO SUL",
  "CRUZ ALTA",
  "CRUZALTENSE",
  "DAVID CANABARRO",
  "DERRUBADAS",
  "DEZESSEIS DE NOVEMBRO",
  "DOIS IRMAOS DAS MISSOES",
  "DOIS LAJEADOS",
  "DOUTOR MAURICIO CARDOSO",
  "ENGENHO VELHO",
  "ENTRE RIOS DO SUL",
  "ENTRE-IJUIS",
  "EREBANGO",
  "ERECHIM",
  "ERNESTINA",
  "ERVAL GRANDE",
  "ERVAL SECO",
  "ESMERALDA",
  "ESPERANCA DO SUL",
  "ESPUMOSO",
  "ESTACAO",
  "ESTRELA VELHA",
  "EUGENIO DE CASTRO",
  "FAGUNDES VARELA",
  "FARROUPILHA",
  "FAXINALZINHO",
  "FELIZ",
  "FLORES DA CUNHA",
  "FORTALEZA DOS VALOS",
  "FREDERICO WESTPHALEN",
  "GARIBALDI",
  "GAURAMA",
  "GENTIL",
  "GETULIO VARGAS",
  "GIRUA",
  "GLORINHA",
  "GRAMADO",
  "GRAMADO DOS LOUREIROS",
  "GRAVATAI",
  "GUABIJU",
  "GUAPORE",
  "GUARANI DAS MISSOES",
  "HORIZONTINA",
  "HUMAITA",
  "IBIRAIARAS",
  "IBIRAPUITA",
  "IBIRUBA",
  "IGREJINHA",
  "IJUI",
  "ILOPOLIS",
  "INDEPENDENCIA",
  "INHACORA",
  "IPE",
  "IPIRANGA DO SUL",
  "IRAI",
  "ITAPUCA",
  "ITATIBA DO SUL",
  "JACUTINGA",
  "JAQUIRANA",
  "JARI",
  "JOIA",
  "JULIO DE CASTILHOS",
  "LAGOA DOS TRES CANTOS",
  "LAGOA VERMELHA",
  "LAJEADO DO BUGRE",
  "LIBERATO SALZANO",
  "LINHA NOVA",
  "MACHADINHO",
  "MARAU",
  "MARCELINO RAMOS",
  "MARIANO MORO",
  "MAXIMILIANO DE ALMEIDA",
  "MIRAGUAI",
  "MONTAURI",
  "MONTE ALEGRE DOS CAMPOS",
  "MONTE BELO DO SUL",
  "MORMACO",
  "MUITOS CAPOES",
  "MULITERNO",
  "NAO-ME-TOQUE",
  "NONOAI",
  "NOVA ALVORADA",
  "NOVA ARACA",
  "NOVA BASSANO",
  "NOVA BOA VISTA",
  "NOVA CANDELARIA",
  "NOVA HARTZ",
  "NOVA PADUA",
  "NOVA PALMA",
  "NOVA PETROPOLIS",
  "NOVA PRATA",
  "NOVA ROMA DO SUL",
  "NOVO BARREIRO",
  "NOVO MACHADO",
  "NOVO XINGU",
  "PAIM FILHO",
  "PALMEIRA DAS MISSOES",
  "PALMITINHO",
  "PARAI",
  "PAROBE",
  "PASSO FUNDO",
  "PAULO BENTO",
  "PEJUCARA",
  "PICADA CAFE",
  "PINHAL DA SERRA",
  "PINHAL GRANDE",
  "PINHEIRINHO DO VALE",
  "PIRAPO",
  "PLANALTO",
  "PONTE PRETA",
  "PORTO LUCENA",
  "PORTO MAUA",
  "PORTO VERA CRUZ",
  "PORTO XAVIER",
  "PROTASIO ALVES",
  "PUTINGA",
  "QUATRO IRMAOS",
  "QUINZE DE NOVEMBRO",
  "REDENTORA",
  "RIO DOS INDIOS",
  "RIOZINHO",
  "ROLADOR",
  "ROLANTE",
  "RONDA ALTA",
  "RONDINHA",
  "ROQUE GONZALES",
  "SAGRADA FAMILIA",
  "SALDANHA MARINHO",
  "SALTO DO JACUI",
  "SALVADOR DAS MISSOES",
  "SANANDUVA",
  "SANTA BARBARA DO SUL",
  "SANTA ROSA",
  "SANTA TEREZA",
  "SANTO ANGELO",
  "SANTO ANTONIO DA PATRULHA",
  "SANTO ANTONIO DO PALMA",
  "SANTO AUGUSTO",
  "SANTO CRISTO",
  "SANTO EXPEDITO DO SUL",
  "SAO DOMINGOS DO SUL",
  "SAO FRANCISCO DE PAULA",
  "SAO JOAO DA URTIGA",
  "SAO JORGE",
  "SAO JOSE DAS MISSOES",
  "SAO JOSE DO INHACORA",
  "SAO JOSE DO OURO",
  "SAO JOSE DOS AUSENTES",
  "SAO LUIZ GONZAGA",
  "SAO MARCOS",
  "SAO MARTINHO",
  "SAO MARTINHO DA SERRA",
  "SAO NICOLAU",
  "SAO PAULO DAS MISSOES",
  "SAO PEDRO DAS MISSOES",
  "SAO PEDRO DO BUTIA",
  "SAO VALENTIM",
  "SAO VALENTIM DO SUL",
  "SAO VALERIO DO SUL",
  "SAPUCAIA DO SUL",
  "SARANDI",
  "SEBERI",
  "SEDE NOVA",
  "SELBACH",
  "SENADOR SALGADO FILHO",
  "SERAFINA CORREA",
  "SERTAO",
  "SETE DE SETEMBRO",
  "SEVERIANO DE ALMEIDA",
  "SOLEDADE",
  "TAPERA",
  "TAQUARA",
  "TAQUARUCU DO SUL",
  "TENENTE PORTELA",
  "TIO HUGO",
  "TIRADENTES DO SUL",
  "TRES ARROIOS",
  "TRES COROAS",
  "TRES DE MAIO",
  "TRES PALMEIRAS",
  "TRES PASSOS",
  "TRINDADE DO SUL",
  "TUCUNDUVA",
  "TUPANCI DO SUL",
  "TUPANCIRETA",
  "TUPARENDI",
  "UBIRETAMA",
  "UNIAO DA SERRA",
  "VACARIA",
  "VALE REAL",
  "VANINI",
  "VERANOPOLIS",
  "VIADUTOS",
  "VICENTE DUTRA",
  "VICTOR GRAEFF",
  "VILA FLORES",
  "VILA MARIA",
  "VISTA ALEGRE",
  "VISTA ALEGRE DO PRATA",
  "VISTA GAUCHA",
  "VITORIA DAS MISSOES",
  "ALMIRANTE TAMANDARE DO SUL",
  "BARRA FUNDA",
  "CARAZINHO",
  "CHAPADA",
  "COLORADO",
  "COQUEIROS DO SUL",
  "NAO-ME-TOQUE",
  "NOVA BOA VISTA",
  "NOVO BARREIRO",
  "PALMEIRA DAS MISSOES",
  "PASSO FUNDO",
  "PONTAO",
  "SALDANHA MARINHO",
  "SANTA BARBARA DO SUL",
  "SANTO ANTONIO DO PLANALTO",
  "SARANDI",
  "SELBACH",
  "TAPERA",
  "ALVORADA",
  "AMARAL FERRADOR",
  "ARAMBARE",
  "ARROIO DO PADRE",
  "ARROIO DO SAL",
  "ARROIO DOS RATOS",
  "ARROIO GRANDE",
  "BAGE",
  "BALNEARIO PINHAL",
  "BARAO DO TRIUNFO",
  "BARRA DO RIBEIRO",
  "BUTIA",
  "CAMAQUA",
  "CANDIOTA",
  "CANGUCU",
  "CAPAO DA CANOA",
  "CAPAO DO LEAO",
  "CAPIVARI DO SUL",
  "CARAA",
  "CERRITO",
  "CERRO GRANDE DO SUL",
  "CHARQUEADAS",
  "CHUI",
  "CHUVISCA",
  "CIDREIRA",
  "CRISTAL",
  "DOM FELICIANO",
  "DOM PEDRITO",
  "DOM PEDRO DE ALCANTARA",
  "ELDORADO DO SUL",
  "ENCRUZILHADA DO SUL",
  "GUAIBA",
  "HERVAL",
  "HULHA NEGRA",
  "IMBE",
  "ITATI",
  "JAGUARAO",
  "LAVRAS DO SUL",
  "MAMPITUBA",
  "MAQUINE",
  "MARIANA PIMENTEL",
  "MINAS DO LEAO",
  "MORRINHOS DO SUL",
  "MORRO REDONDO",
  "MOSTARDAS",
  "OSORIO",
  "PALMARES DO SUL",
  "PANTANO GRANDE",
  "PEDRAS ALTAS",
  "PEDRO OSORIO",
  "PELOTAS",
  "PINHEIRO MACHADO",
  "PIRATINI",
  "PORTO ALEGRE",
  "RIO GRANDE",
  "SANTA VITORIA DO PALMAR",
  "SANTO ANTONIO DA PATRULHA",
  "SAO JERONIMO",
  "SAO JOSE DO NORTE",
  "SAO LOURENCO DO SUL",
  "SENTINELA DO SUL",
  "SERTAO SANTANA",
  "TAPES",
  "TAVARES",
  "TERRA DE AREIA",
  "TORRES",
  "TRAMANDAI",
  "TRES CACHOEIRAS",
  "TRES FORQUILHAS",
  "TURUCU",
  "VIAMAO",
  "XANGRI-LA",
  "APARECIDA",
  "AFONSO CLAUDIO",
  "AGUA DOCE DO NORTE",
  "AGUIA BRANCA",
  "ALEGRE",
  "ALFREDO CHAVES",
  "ALTO RIO NOVO",
  "ANCHIETA",
  "APIACA",
  "ARACRUZ",
  "ATILIO VIVACQUA",
  "BAIXO GUANDU",
  "BARRA DE SAO FRANCISCO",
  "BOA ESPERANCA",
  "BOM JESUS DO NORTE",
  "BREJETUBA",
  "CACHOEIRO DE ITAPEMIRIM",
  "CARIACICA",
  "CASTELO",
  "COLATINA",
  "CONCEICAO DA BARRA",
  "CONCEICAO DO CASTELO",
  "DIVINO DE SAO LOURENCO",
  "DOMINGOS MARTINS",
  "DORES DO RIO PRETO",
  "ECOPORANGA",
  "FUNDAO",
  "GOVERNADOR LINDENBERG",
  "GUACUI",
  "GUARAPARI",
  "IBATIBA",
  "IBIRACU",
  "IBITIRAMA",
  "ICONHA",
  "IRUPI",
  "ITAGUACU",
  "ITAPEMIRIM",
  "ITARANA",
  "IUNA",
  "JAGUARE",
  "JERONIMO MONTEIRO",
  "JOAO NEIVA",
  "LARANJA DA TERRA",
  "LINHARES",
  "MANTENOPOLIS",
  "MARATAIZES",
  "MARECHAL FLORIANO",
  "MARILANDIA",
  "MIMOSO DO SUL",
  "MONTANHA",
  "MUCURICI",
  "MUNIZ FREIRE",
  "MUQUI",
  "NOVA VENECIA",
  "PANCAS",
  "PEDRO CANARIO",
  "PINHEIROS",
  "PIUMA",
  "PONTO BELO",
  "PRESIDENTE KENNEDY",
  "RIO BANANAL",
  "RIO NOVO DO SUL",
  "SANTA LEOPOLDINA",
  "SANTA MARIA DE JETIBA",
  "SANTA TERESA",
  "SAO DOMINGOS DO NORTE",
  "SAO GABRIEL DA PALHA",
  "SAO JOSE DO CALCADO",
  "SAO MATEUS",
  "SAO ROQUE DO CANAA",
  "SERRA",
  "SOORETAMA",
  "VARGEM ALTA",
  "VENDA NOVA DO IMIGRANTE",
  "VIANA",
  "VILA PAVAO",
  "VILA VALERIO",
  "VILA VELHA",
  "VITORIA",
  "ABADIA DE GOIAS",
  "ABADIANIA",
  "ACREUNA",
  "ADELANDIA",
  "AGUA FRIA DE GOIAS",
  "AGUA LIMPA",
  "AGUAS LINDAS DE GOIAS",
  "ALEXANIA",
  "ALOANDIA",
  "ALTO HORIZONTE",
  "ALTO PARAISO DE GOIAS",
  "ALVORADA DO NORTE",
  "AMARALINA",
  "AMERICANO DO BRASIL",
  "AMORINOPOLIS",
  "ANAPOLIS",
  "ANHANGUERA",
  "ANICUNS",
  "APARECIDA DE GOIANIA",
  "APARECIDA DO RIO DOCE",
  "APORE",
  "ARACU",
  "ARAGARCAS",
  "ARAGOIANIA",
  "ARAGUAPAZ",
  "ARENOPOLIS",
  "ARUANA",
  "AURILANDIA",
  "AVELINOPOLIS",
  "BALIZA",
  "BARRO ALTO",
  "BELA VISTA DE GOIAS",
  "BOM JARDIM DE GOIAS",
  "BOM JESUS DE GOIAS",
  "BONFINOPOLIS",
  "BONOPOLIS",
  "BRAZABRANTES",
  "BRITANIA",
  "BURITI ALEGRE",
  "BURITI DE GOIAS",
  "BURITINOPOLIS",
  "CABECEIRAS",
  "CACHOEIRA ALTA",
  "CACHOEIRA DE GOIAS",
  "CACHOEIRA DOURADA",
  "CACU",
  "CAIAPONIA",
  "CALDAS NOVAS",
  "CALDAZINHA",
  "CAMPESTRE DE GOIAS",
  "CAMPINACU",
  "CAMPINORTE",
  "CAMPO ALEGRE DE GOIAS",
  "CAMPO LIMPO DE GOIAS",
  "CAMPOS BELOS",
  "CAMPOS VERDES",
  "CARMO DO RIO VERDE",
  "CASTELANDIA",
  "CATALAO",
  "CATURAI",
  "CAVALCANTE",
  "CERES",
  "CEZARINA",
  "CHAPADAO DO CEU",
  "CIDADE OCIDENTAL",
  "COCALZINHO DE GOIAS",
  "COLINAS DO SUL",
  "CORREGO DO OURO",
  "CORUMBA DE GOIAS",
  "CORUMBAIBA",
  "CRISTALINA",
  "CRISTIANOPOLIS",
  "CRIXAS",
  "CROMINIA",
  "CUMARI",
  "DAMIANOPOLIS",
  "DAMOLANDIA",
  "DAVINOPOLIS",
  "DIORAMA",
  "DIVINOPOLIS DE GOIAS",
  "DOVERLANDIA",
  "EDEALINA",
  "EDEIA",
  "ESTRELA DO NORTE",
  "FAINA",
  "FAZENDA NOVA",
  "FIRMINOPOLIS",
  "FLORES DE GOIAS",
  "FORMOSA",
  "FORMOSO",
  "GAMELEIRA DE GOIAS",
  "GOIANAPOLIS",
  "GOIANDIRA",
  "GOIANESIA",
  "GOIANIA",
  "GOIANIRA",
  "GOIAS",
  "GOIATUBA",
  "GOUVELANDIA",
  "GUAPO",
  "GUARAITA",
  "GUARANI DE GOIAS",
  "GUARINOS",
  "HEITORAI",
  "HIDROLANDIA",
  "HIDROLINA",
  "IACIARA",
  "INACIOLANDIA",
  "INDIARA",
  "INHUMAS",
  "IPAMERI",
  "IPIRANGA DE GOIAS",
  "IPORA",
  "ISRAELANDIA",
  "ITABERAI",
  "ITAGUARI",
  "ITAGUARU",
  "ITAJA",
  "ITAPACI",
  "ITAPIRAPUA",
  "ITAPURANGA",
  "ITARUMA",
  "ITAUCU",
  "ITUMBIARA",
  "IVOLANDIA",
  "JANDAIA",
  "JARAGUA",
  "JATAI",
  "JAUPACI",
  "JESUPOLIS",
  "JOVIANIA",
  "JUSSARA",
  "LAGOA SANTA",
  "LEOPOLDO DE BULHOES",
  "LUZIANIA",
  "MAIRIPOTABA",
  "MAMBAI",
  "MARA ROSA",
  "MARZAGAO",
  "MATRINCHA",
  "MAURILANDIA",
  "MIMOSO DE GOIAS",
  "MINACU",
  "MINEIROS",
  "MOIPORA",
  "MONTE ALEGRE DE GOIAS",
  "MONTES CLAROS DE GOIAS",
  "MONTIVIDIU",
  "MONTIVIDIU DO NORTE",
  "MORRINHOS",
  "MORRO AGUDO DE GOIAS",
  "MOSSAMEDES",
  "MOZARLANDIA",
  "MUNDO NOVO",
  "MUTUNOPOLIS",
  "NAZARIO",
  "NEROPOLIS",
  "NIQUELANDIA",
  "NOVA AMERICA",
  "NOVA AURORA",
  "NOVA CRIXAS",
  "NOVA GLORIA",
  "NOVA IGUACU DE GOIAS",
  "NOVA ROMA",
  "NOVA VENEZA",
  "NOVO BRASIL",
  "NOVO GAMA",
  "NOVO PLANALTO",
  "ORIZONA",
  "OURO VERDE DE GOIAS",
  "OUVIDOR",
  "PADRE BERNARDO",
  "PALESTINA DE GOIAS",
  "PALMEIRAS DE GOIAS",
  "PALMELO",
  "PALMINOPOLIS",
  "PANAMA",
  "PARANAIGUARA",
  "PARAUNA",
  "PEROLANDIA",
  "PETROLINA DE GOIAS",
  "PILAR DE GOIAS",
  "PIRACANJUBA",
  "PIRANHAS",
  "PIRENOPOLIS",
  "PIRES DO RIO",
  "PLANALTINA",
  "PONTALINA",
  "PORANGATU",
  "PORTEIRAO",
  "PORTELANDIA",
  "POSSE",
  "PROFESSOR JAMIL",
  "QUIRINOPOLIS",
  "RIALMA",
  "RIANAPOLIS",
  "RIO QUENTE",
  "RIO VERDE",
  "RUBIATABA",
  "SANCLERLANDIA",
  "SANTA BARBARA DE GOIAS",
  "SANTA CRUZ DE GOIAS",
  "SANTA FE DE GOIAS",
  "SANTA HELENA DE GOIAS",
  "SANTA ISABEL",
  "SANTA RITA DO ARAGUAIA",
  "SANTA RITA DO NOVO DESTINO",
  "SANTA ROSA DE GOIAS",
  "SANTA TEREZA DE GOIAS",
  "SANTA TEREZINHA DE GOIAS",
  "SANTO ANTONIO DA BARRA",
  "SANTO ANTONIO DE GOIAS",
  "SANTO ANTONIO DO DESCOBERTO",
  "SAO DOMINGOS",
  "SAO FRANCISCO DE GOIAS",
  "SAO JOAO D ALIANCA",
  "SAO JOAO DA PARAUNA",
  "SAO LUIS DE MONTES BELOS",
  "SAO LUIZ DO NORTE",
  "SAO MIGUEL DO ARAGUAIA",
  "SAO MIGUEL DO PASSA QUATRO",
  "SAO PATRICIO",
  "SAO SIMAO",
  "SENADOR CANEDO",
  "SERRANOPOLIS",
  "SILVANIA",
  "SIMOLANDIA",
  "SITIO D ABADIA",
  "TAQUARAL DE GOIAS",
  "TERESINA DE GOIAS",
  "TEREZOPOLIS DE GOIAS",
  "TRES RANCHOS",
  "TRINDADE",
  "TROMBAS",
  "TURVANIA",
  "TURVELANDIA",
  "UIRAPURU",
  "URUACU",
  "URUANA",
  "URUTAI",
  "VALPARAISO DE GOIAS",
  "VARJAO",
  "VIANOPOLIS",
  "VICENTINOPOLIS",
  "VILA BOA",
  "VILA PROPICIO",
  "BRASILIA",
  "ABAIRA",
  "ABARE",
  "ACAJUTIBA",
  "ADUSTINA",
  "AGUA FRIA",
  "AIQUARA",
  "ALAGOINHAS",
  "ALCOBACA",
  "ALMADINA",
  "AMARGOSA",
  "AMELIA RODRIGUES",
  "AMERICA DOURADA",
  "ANAGE",
  "ANDARAI",
  "ANDORINHA",
  "ANGICAL",
  "ANGUERA",
  "ANTAS",
  "ANTONIO CARDOSO",
  "ANTONIO GONCALVES",
  "APORA",
  "APUAREMA",
  "ARACAS",
  "ARACATU",
  "ARACI",
  "ARAMARI",
  "ARATACA",
  "ARATUIPE",
  "AURELINO LEAL",
  "BAIANOPOLIS",
  "BAIXA GRANDE",
  "BANZAE",
  "BARRA",
  "BARRA DA ESTIVA",
  "BARRA DO CHOCA",
  "BARRA DO MENDES",
  "BARRA DO ROCHA",
  "BARREIRAS",
  "BARRO ALTO",
  "BARRO PRETO",
  "BARROCAS",
  "BELMONTE",
  "BELO CAMPO",
  "BIRITINGA",
  "BOA NOVA",
  "BOA VISTA DO TUPIM",
  "BOM JESUS DA LAPA",
  "BOM JESUS DA SERRA",
  "BONINAL",
  "BONITO",
  "BOQUIRA",
  "BOTUPORA",
  "BREJOES",
  "BREJOLANDIA",
  "BROTAS DE MACAUBAS",
  "BRUMADO",
  "BUERAREMA",
  "BURITIRAMA",
  "CAATIBA",
  "CABACEIRAS DO PARAGUACU",
  "CACHOEIRA",
  "CACULE",
  "CAEM",
  "CAETANOS",
  "CAETITE",
  "CAFARNAUM",
  "CAIRU",
  "CALDEIRAO GRANDE",
  "CAMACAN",
  "CAMACARI",
  "CAMAMU",
  "CAMPO ALEGRE DE LOURDES",
  "CAMPO FORMOSO",
  "CANAPOLIS",
  "CANARANA",
  "CANAVIEIRAS",
  "CANDEAL",
  "CANDEIAS",
  "CANDIBA",
  "CANDIDO SALES",
  "CANSANCAO",
  "CANUDOS",
  "CAPELA DO ALTO ALEGRE",
  "CAPIM GROSSO",
  "CARAIBAS",
  "CARAVELAS",
  "CARDEAL DA SILVA",
  "CARINHANHA",
  "CASA NOVA",
  "CASTRO ALVES",
  "CATOLANDIA",
  "CATU",
  "CATURAMA",
  "CENTRAL",
  "CHORROCHO",
  "CICERO DANTAS",
  "CIPO",
  "COARACI",
  "COCOS",
  "CONCEICAO DA FEIRA",
  "CONCEICAO DO ALMEIDA",
  "CONCEICAO DO COITE",
  "CONCEICAO DO JACUIPE",
  "CONDE",
  "CONDEUBA",
  "CONTENDAS DO SINCORA",
  "CORACAO DE MARIA",
  "CORDEIROS",
  "CORIBE",
  "CORONEL JOAO SA",
  "CORRENTINA",
  "COTEGIPE",
  "CRAVOLANDIA",
  "CRISOPOLIS",
  "CRISTOPOLIS",
  "CRUZ DAS ALMAS",
  "CURACA",
  "DARIO MEIRA",
  "DIAS D AVILA",
  "DOM BASILIO",
  "DOM MACEDO COSTA",
  "ELISIO MEDRADO",
  "ENCRUZILHADA",
  "ENTRE RIOS",
  "ERICO CARDOSO",
  "ESPLANADA",
  "EUCLIDES DA CUNHA",
  "EUNAPOLIS",
  "FATIMA",
  "FEIRA DA MATA",
  "FEIRA DE SANTANA",
  "FILADELFIA",
  "FIRMINO ALVES",
  "FLORESTA AZUL",
  "FORMOSA DO RIO PRETO",
  "GANDU",
  "GAVIAO",
  "GENTIO DO OURO",
  "GLORIA",
  "GONGOGI",
  "GOVERNADOR MANGABEIRA",
  "GUAJERU",
  "GUANAMBI",
  "GUARATINGA",
  "HELIOPOLIS",
  "IACU",
  "IBIASSUCE",
  "IBICARAI",
  "IBICOARA",
  "IBICUI",
  "IBIPEBA",
  "IBIPITANGA",
  "IBIQUERA",
  "IBIRAPITANGA",
  "IBIRAPUA",
  "IBIRATAIA",
  "IBITIARA",
  "IBITITA",
  "IBOTIRAMA",
  "ICHU",
  "IGAPORA",
  "IGRAPIUNA",
  "IGUAI",
  "ILHEUS",
  "INHAMBUPE",
  "IPECAETA",
  "IPIAU",
  "IPIRA",
  "IPUPIARA",
  "IRAJUBA",
  "IRAMAIA",
  "IRAQUARA",
  "IRARA",
  "IRECE",
  "ITABELA",
  "ITABERABA",
  "ITABUNA",
  "ITACARE",
  "ITAETE",
  "ITAGI",
  "ITAGIBA",
  "ITAGIMIRIM",
  "ITAGUACU DA BAHIA",
  "ITAJU DO COLONIA",
  "ITAJUIPE",
  "ITAMARAJU",
  "ITAMARI",
  "ITAMBE",
  "ITANAGRA",
  "ITANHEM",
  "ITAPARICA",
  "ITAPE",
  "ITAPEBI",
  "ITAPETINGA",
  "ITAPICURU",
  "ITAPITANGA",
  "ITAQUARA",
  "ITARANTIM",
  "ITATIM",
  "ITIRUCU",
  "ITIUBA",
  "ITORORO",
  "ITUACU",
  "ITUBERA",
  "IUIU",
  "JABORANDI",
  "JACARACI",
  "JACOBINA",
  "JAGUAQUARA",
  "JAGUARARI",
  "JAGUARIPE",
  "JEQUIE",
  "JEREMOABO",
  "JIQUIRICA",
  "JITAUNA",
  "JOAO DOURADO",
  "JUAZEIRO",
  "JUCURUCU",
  "JUSSARA",
  "JUSSARI",
  "JUSSIAPE",
  "LAFAIETE COUTINHO",
  "LAGOA REAL",
  "LAJE",
  "LAJEDAO",
  "LAJEDINHO",
  "LAJEDO DO TABOCAL",
  "LAMARAO",
  "LAPAO",
  "LAURO DE FREITAS",
  "LENCOIS",
  "LICINIO DE ALMEIDA",
  "LIVRAMENTO DE NOSSA SENHORA",
  "LUIS EDUARDO MAGALHAES",
  "MACAJUBA",
  "MACARANI",
  "MACAUBAS",
  "MACURURE",
  "MADRE DE DEUS",
  "MAETINGA",
  "MAIQUINIQUE",
  "MAIRI",
  "MALHADA",
  "MALHADA DE PEDRAS",
  "MANOEL VITORINO",
  "MANSIDAO",
  "MARACAS",
  "MARAGOGIPE",
  "MARAU",
  "MARCIONILIO SOUZA",
  "MASCOTE",
  "MATA DE SAO JOAO",
  "MATINA",
  "MEDEIROS NETO",
  "MIGUEL CALMON",
  "MILAGRES",
  "MIRANGABA",
  "MIRANTE",
  "MONTE SANTO",
  "MORPARA",
  "MORRO DO CHAPEU",
  "MORTUGABA",
  "MUCUGE",
  "MUCURI",
  "MULUNGU DO MORRO",
  "MUNDO NOVO",
  "MUNIZ FERREIRA",
  "MUQUEM DE SAO FRANCISCO",
  "MURITIBA",
  "MUTUIPE",
  "NAZARE",
  "NILO PECANHA",
  "NORDESTINA",
  "NOVA CANAA",
  "NOVA FATIMA",
  "NOVA IBIA",
  "NOVA ITARANA",
  "NOVA REDENCAO",
  "NOVA SOURE",
  "NOVA VICOSA",
  "NOVO HORIZONTE",
  "NOVO TRIUNFO",
  "OLINDINA",
  "OLIVEIRA DOS BREJINHOS",
  "OURICANGAS",
  "OUROLANDIA",
  "PALMAS DE MONTE ALTO",
  "PALMEIRAS",
  "PARAMIRIM",
  "PARATINGA",
  "PARIPIRANGA",
  "PAU BRASIL",
  "PAULO AFONSO",
  "PE DE SERRA",
  "PEDRAO",
  "PEDRO ALEXANDRE",
  "PIATA",
  "PILAO ARCADO",
  "PINDAI",
  "PINDOBACU",
  "PINTADAS",
  "PIRAI DO NORTE",
  "PIRIPA",
  "PIRITIBA",
  "PLANALTINO",
  "PLANALTO",
  "POCOES",
  "POJUCA",
  "PONTO NOVO",
  "PORTO SEGURO",
  "POTIRAGUA",
  "PRADO",
  "PRESIDENTE DUTRA",
  "PRESIDENTE JANIO QUADROS",
  "PRESIDENTE TANCREDO NEVES",
  "QUEIMADAS",
  "QUIJINGUE",
  "QUIXABEIRA",
  "RAFAEL JAMBEIRO",
  "REMANSO",
  "RETIROLANDIA",
  "RIACHAO DAS NEVES",
  "RIACHAO DO JACUIPE",
  "RIACHO DE SANTANA",
  "RIBEIRA DO AMPARO",
  "RIBEIRAO DO POMBAL",
  "RIBEIRAO DO LARGO",
  "RIO DE CONTAS",
  "RIO DO ANTONIO",
  "RIO DO PIRES",
  "RODELAS",
  "RUY BARBOSA",
  "SALINAS DA MARGARIDA",
  "SALVADOR",
  "SANTA BARBARA",
  "SANTA BRIGIDA",
  "SANTA CRUZ CABRALIA",
  "SANTA CRUZ DA VITORIA",
  "SANTA INES",
  "SANTA LUZIA",
  "SANTA MARIA DA VITORIA",
  "SANTA RITA DE CASSIA",
  "SANTA TERESINHA",
  "SANTALUZ",
  "SANTANA",
  "SANTANOPOLIS",
  "SANTO AMARO",
  "SANTO ANTONIO DE JESUS",
  "SANTO ESTEVAO",
  "SAO DESIDERIO",
  "SAO DOMINGOS",
  "SAO FELIPE",
  "SAO FELIX",
  "SAO FELIX DO CORIBE",
  "SAO FRANCISCO DO CONDE",
  "SAO GABRIEL",
  "SAO GONCALO DOS CAMPOS",
  "SAO JOSE DA VITORIA",
  "SAO JOSE DO JACUIPE",
  "SAO MIGUEL DAS MATAS",
  "SAO SEBASTIAO DO PASSE",
  "SAPEACU",
  "SATIRO DIAS",
  "SAUBARA",
  "SAUDE",
  "SEABRA",
  "SEBASTIAO LARANJEIRAS",
  "SENHOR DO BONFIM",
  "SENTO SE",
  "SERRA DO RAMALHO",
  "SERRA DOURADA",
  "SERRA PRETA",
  "SERRINHA",
  "SERROLANDIA",
  "SIMOES FILHO",
  "SITIO DO MATO",
  "SITIO DO QUINTO",
  "SOBRADINHO",
  "SOUTO SOARES",
  "TABOCAS DO BREJO VELHO",
  "TANHACU",
  "TANQUE NOVO",
  "TANQUINHO",
  "TAPEROA",
  "TAPIRAMUTA",
  "TEIXEIRA DE FREITAS",
  "TEODORO SAMPAIO",
  "TEOFILANDIA",
  "TEOLANDIA",
  "TERRA NOVA",
  "TREMEDAL",
  "TUCANO",
  "UAUA",
  "UBAIRA",
  "UBAITABA",
  "UBATA",
  "UIBAI",
  "UMBURANAS",
  "UNA",
  "URANDI",
  "URUCUCA",
  "UTINGA",
  "VALENCA",
  "VALENTE",
  "VARZEA DA ROCA",
  "VARZEA DO POCO",
  "VARZEA NOVA",
  "VARZEDO",
  "VERA CRUZ",
  "VEREDA",
  "VITORIA DA CONQUISTA",
  "WAGNER",
  "WANDERLEY",
  "WENCESLAU GUIMARAES",
  "XIQUE-XIQUE",
  "AMPARO DE SAO FRANCISCO",
  "AQUIDABA",
  "ARACAJU",
  "AREIA BRANCA",
  "BARRA DOS COQUEIROS",
  "BREJO GRANDE",
  "CAMPO DO BRITO",
  "CANHOBA",
  "CANINDE DE SAO FRANCISCO",
  "CAPELA",
  "CARIRA",
  "CARMOPOLIS",
  "CEDRO DE SAO JOAO",
  "CUMBE",
  "DIVINA PASTORA",
  "FEIRA NOVA",
  "FREI PAULO",
  "GARARU",
  "GENERAL MAYNARD",
  "GRACHO CARDOSO",
  "ILHA DAS FLORES",
  "ITABAIANA",
  "ITABI",
  "ITAPORANGA D AJUDA",
  "JAPARATUBA",
  "JAPOATA",
  "LAGARTO",
  "LARANJEIRAS",
  "MACAMBIRA",
  "MALHADA DOS BOIS",
  "MALHADOR",
  "MARUIM",
  "MOITA BONITA",
  "MONTE ALEGRE DE SERGIPE",
  "MURIBECA",
  "NEOPOLIS",
  "NOSSA SENHORA APARECIDA",
  "NOSSA SENHORA DA GLORIA",
  "NOSSA SENHORA DAS DORES",
  "NOSSA SENHORA DE LOURDES",
  "NOSSA SENHORA DO SOCORRO",
  "PACATUBA",
  "PEDRA MOLE",
  "PINHAO",
  "PIRAMBU",
  "POCO REDONDO",
  "POCO VERDE",
  "PORTO DA FOLHA",
  "PROPRIA",
  "RIACHUELO",
  "RIBEIROPOLIS",
  "ROSARIO DO CATETE",
  "SALGADO",
  "SANTA ROSA DE LIMA",
  "SANTANA DO SAO FRANCISCO",
  "SANTO AMARO DAS BROTAS",
  "SAO CRISTOVAO",
  "SAO DOMINGOS",
  "SAO FRANCISCO",
  "SAO MIGUEL DO ALEIXO",
  "SIMAO DIAS",
  "SIRIRI",
  "TELHA",
  "ACARI",
  "ACU",
  "AFONSO BEZERRA",
  "AGUA NOVA",
  "ALEXANDRIA",
  "ALMINO AFONSO",
  "ALTO DO RODRIGUES",
  "ANGICOS",
  "ANTONIO MARTINS",
  "APODI",
  "AREIA BRANCA",
  "AREZ",
  "AUGUSTO SEVERO",
  "BAIA FORMOSA",
  "BARAUNA",
  "BARCELONA",
  "BENTO FERNANDES",
  "BODO",
  "BOM JESUS",
  "BREJINHO",
  "CAICARA DO NORTE",
  "CAICARA DO RIO DO VENTO",
  "CAICO",
  "CAMPO REDONDO",
  "CANGUARETAMA",
  "CARAUBAS",
  "CARNAUBA DOS DANTAS",
  "CARNAUBAIS",
  "CEARA-MIRIM",
  "CERRO CORA",
  "CORONEL EZEQUIEL",
  "CORONEL JOAO PESSOA",
  "CRUZETA",
  "CURRAIS NOVOS",
  "DOUTOR SEVERIANO",
  "ENCANTO",
  "EQUADOR",
  "ESPIRITO SANTO",
  "EXTREMOZ",
  "FELIPE GUERRA",
  "FERNANDO PEDROZA",
  "FLORANIA",
  "FRANCISCO DANTAS",
  "FRUTUOSO GOMES",
  "GALINHOS",
  "GOIANINHA",
  "GOVERNADOR DIX-SEPT ROSADO",
  "GROSSOS",
  "GUAMARE",
  "IELMO MARINHO",
  "IPANGUACU",
  "IPUEIRA",
  "ITAJA",
  "ITAU",
  "JACANA",
  "JANDAIRA",
  "JANDUIS",
  "JANUARIO CICCO",
  "JAPI",
  "JARDIM DE ANGICOS",
  "JARDIM DE PIRANHAS",
  "JARDIM DO SERIDO",
  "JOAO CAMARA",
  "JOAO DIAS",
  "JOSE DA PENHA",
  "JUCURUTU",
  "JUNDIA",
  "LAGOA D ANTA",
  "LAGOA DE PEDRAS",
  "LAGOA DE VELHOS",
  "LAGOA NOVA",
  "LAGOA SALGADA",
  "LAJES",
  "LAJES PINTADAS",
  "LUCRECIA",
  "LUIS GOMES",
  "MACAIBA",
  "MACAU",
  "MAJOR SALES",
  "MARCELINO VIEIRA",
  "MARTINS",
  "MAXARANGUAPE",
  "MESSIAS TARGINO",
  "MONTANHAS",
  "MONTE ALEGRE",
  "MONTE DAS GAMELEIRAS",
  "MOSSORO",
  "NATAL",
  "NISIA FLORESTA",
  "NOVA CRUZ",
  "OLHO-D AGUA DO BORGES",
  "OURO BRANCO",
  "PARANA",
  "PARAU",
  "PARAZINHO",
  "PARELHAS",
  "PARNAMIRIM",
  "PASSA E FICA",
  "PASSAGEM",
  "PATU",
  "PAU DOS FERROS",
  "PEDRA GRANDE",
  "PEDRA PRETA",
  "PEDRO AVELINO",
  "PEDRO VELHO",
  "PENDENCIAS",
  "PILOES",
  "POCO BRANCO",
  "PORTALEGRE",
  "PORTO DO MANGUE",
  "PRESIDENTE JUSCELINO",
  "PUREZA",
  "RAFAEL FERNANDES",
  "RAFAEL GODEIRO",
  "RIACHO DA CRUZ",
  "RIACHO DE SANTANA",
  "RIACHUELO",
  "RIO DO FOGO",
  "RODOLFO FERNANDES",
  "RUY BARBOSA",
  "SANTA CRUZ",
  "SANTA MARIA",
  "SANTANA DO MATOS",
  "SANTANA DO SERIDO",
  "SANTO ANTONIO",
  "SAO BENTO DO NORTE",
  "SAO BENTO DO TRAIRI",
  "SAO FERNANDO",
  "SAO FRANCISCO DO OESTE",
  "SAO GONCALO DO AMARANTE",
  "SAO JOAO DO SABUGI",
  "SAO JOSE DE MIPIBU",
  "SAO JOSE DO CAMPESTRE",
  "SAO JOSE DO SERIDO",
  "SAO MIGUEL",
  "SAO MIGUEL DO GOSTOSO",
  "SAO PAULO DO POTENGI",
  "SAO PEDRO",
  "SAO RAFAEL",
  "SAO TOME",
  "SAO VICENTE",
  "SENADOR ELOI DE SOUZA",
  "SENADOR GEORGINO AVELINO",
  "SERRA DE SAO BENTO",
  "SERRA DO MEL",
  "SERRA NEGRA DO NORTE",
  "SERRINHA",
  "SERRINHA DOS PINTOS",
  "SEVERIANO MELO",
  "SITIO NOVO",
  "TABOLEIRO GRANDE",
  "TAIPU",
  "TANGARA",
  "TENENTE ANANIAS",
  "TENENTE LAURENTINO CRUZ",
  "TIBAU",
  "TIBAU DO SUL",
  "TIMBAUBA DOS BATISTAS",
  "TOUROS",
  "TRIUNFO POTIGUAR",
  "UMARIZAL",
  "UPANEMA",
  "VARZEA",
  "VENHA-VER",
  "VERA CRUZ",
  "VICOSA",
  "VILA FLOR",
  "AGUA BRANCA",
  "ANADIA",
  "ARAPIRACA",
  "ATALAIA",
  "BARRA DE SANTO ANTONIO",
  "BARRA DE SAO MIGUEL",
  "BATALHA",
  "BELEM",
  "BELO MONTE",
  "BOCA DA MATA",
  "BRANQUINHA",
  "CACIMBINHAS",
  "CAJUEIRO",
  "CAMPESTRE",
  "CAMPO ALEGRE",
  "CAMPO GRANDE",
  "CANAPI",
  "CAPELA",
  "CARNEIROS",
  "CHA PRETA",
  "COITE DO NOIA",
  "COLONIA LEOPOLDINA",
  "COQUEIRO SECO",
  "CORURIPE",
  "CRAIBAS",
  "DELMIRO GOUVEIA",
  "DOIS RIACHOS",
  "ESTRELA DE ALAGOAS",
  "FEIRA GRANDE",
  "FELIZ DESERTO",
  "FLEXEIRAS",
  "GIRAU DO PONCIANO",
  "IBATEGUARA",
  "IGACI",
  "IGREJA NOVA",
  "INHAPI",
  "JACARE DOS HOMENS",
  "JACUIPE",
  "JAPARATINGA",
  "JARAMATAIA",
  "JEQUIA DA PRAIA",
  "JOAQUIM GOMES",
  "JUNDIA",
  "JUNQUEIRO",
  "LAGOA DA CANOA",
  "LIMOEIRO DE ANADIA",
  "MACEIO",
  "MAJOR ISIDORO",
  "MAR VERMELHO",
  "MARAGOGI",
  "MARAVILHA",
  "MARECHAL DEODORO",
  "MARIBONDO",
  "MATA GRANDE",
  "MATRIZ DE CAMARAGIBE",
  "MESSIAS",
  "MINADOR DO NEGRAO",
  "MONTEIROPOLIS",
  "MURICI",
  "NOVO LINO",
  "OLHO D AGUA DAS FLORES",
  "OLHO D AGUA DO CASADO",
  "OLHO D AGUA GRANDE",
  "OLIVENCA",
  "OURO BRANCO",
  "PALESTINA",
  "PALMEIRA DOS INDIOS",
  "PAO DE ACUCAR",
  "PARICONHA",
  "PARIPUEIRA",
  "PASSO DE CAMARAGIBE",
  "PAULO JACINTO",
  "PENEDO",
  "PIACABUCU",
  "PILAR",
  "PINDOBA",
  "PIRANHAS",
  "POCO DAS TRINCHEIRAS",
  "PORTO CALVO",
  "PORTO DE PEDRAS",
  "PORTO REAL DO COLEGIO",
  "QUEBRANGULO",
  "RIO LARGO",
  "ROTEIRO",
  "SANTA LUZIA DO NORTE",
  "SANTANA DO IPANEMA",
  "SANTANA DO MUNDAU",
  "SAO BRAS",
  "SAO JOSE DA LAJE",
  "SAO JOSE DA TAPERA",
  "SAO LUIS DO QUITUNDE",
  "SAO MIGUEL DOS CAMPOS",
  "SAO MIGUEL DOS MILAGRES",
  "SAO SEBASTIAO",
  "SATUBA",
  "SENADOR RUI PALMEIRA",
  "TANQUE D ARCA",
  "TAQUARANA",
  "TEOTONIO VILELA",
  "TRAIPU",
  "UNIAO DOS PALMARES",
  "VICOSA",
  "ABREULANDIA",
  "AGUIARNOPOLIS",
  "ALIANCA DO TOCANTINS",
  "ALMAS",
  "ALVORADA",
  "ANANAS",
  "ANGICO",
  "APARECIDA DO RIO NEGRO",
  "ARAGOMINAS",
  "ARAGUACEMA",
  "ARAGUACU",
  "ARAGUAINA",
  "ARAGUANA",
  "ARAGUATINS",
  "ARAPOEMA",
  "ARRAIAS",
  "AUGUSTINOPOLIS",
  "AURORA DO TOCANTINS",
  "AXIXA DO TOCANTINS",
  "BABACULANDIA",
  "BANDEIRANTES DO TOCANTINS",
  "BARRA DO OURO",
  "BARROLANDIA",
  "BERNARDO SAYAO",
  "BOM JESUS DO TOCANTINS",
  "BRASILANDIA DO TOCANTINS",
  "BREJINHO DE NAZARE",
  "BURITI DO TOCANTINS",
  "CACHOEIRINHA",
  "CAMPOS LINDOS",
  "CARIRI DO TOCANTINS",
  "CARMOLANDIA",
  "CARRASCO BONITO",
  "CASEARA",
  "CENTENARIO",
  "CHAPADA DA NATIVIDADE",
  "CHAPADA DE AREIA",
  "COLINAS DO TOCANTINS",
  "COLMEIA",
  "COMBINADO",
  "CONCEICAO DO TOCANTINS",
  "COUTO DE MAGALHAES",
  "CRISTALANDIA",
  "CRIXAS DO TOCANTINS",
  "DARCINOPOLIS",
  "DIANOPOLIS",
  "DIVINOPOLIS DO TOCANTINS",
  "DOIS IRMAOS DO TOCANTINS",
  "DUERE",
  "ESPERANTINA",
  "FATIMA",
  "FIGUEIROPOLIS",
  "FILADELFIA",
  "FORMOSO DO ARAGUAIA",
  "FORTALEZA DO TABOCAO",
  "GOIANORTE",
  "GOIATINS",
  "GUARAI",
  "GURUPI",
  "IPUEIRAS",
  "ITACAJA",
  "ITAGUATINS",
  "ITAPIRATINS",
  "ITAPORA DO TOCANTINS",
  "JAU DO TOCANTINS",
  "JUARINA",
  "LAGOA DA CONFUSAO",
  "LAGOA DO TOCANTINS",
  "LAJEADO",
  "LAVANDEIRA",
  "LIZARDA",
  "LUZINOPOLIS",
  "MARIANOPOLIS DO TOCANTINS",
  "MATEIROS",
  "MAURILANDIA DO TOCANTINS",
  "MIRACEMA DO TOCANTINS",
  "MIRANORTE",
  "MONTE DO CARMO",
  "MONTE SANTO DO TOCANTINS",
  "MURICILANDIA",
  "NATIVIDADE",
  "NAZARE",
  "NOVA OLINDA",
  "NOVA ROSALANDIA",
  "NOVO ACORDO",
  "NOVO ALEGRE",
  "NOVO JARDIM",
  "OLIVEIRA DE FATIMA",
  "PALMAS",
  "PALMEIRANTE",
  "PALMEIRAS DO TOCANTINS",
  "PALMEIROPOLIS",
  "PARAISO DO TOCANTINS",
  "PARANA",
  "PAU D ARCO",
  "PEDRO AFONSO",
  "PEIXE",
  "PEQUIZEIRO",
  "PINDORAMA DO TOCANTINS",
  "PIRAQUE",
  "PIUM",
  "PONTE ALTA DO BOM JESUS",
  "PONTE ALTA DO TOCANTINS",
  "PORTO ALEGRE DO TOCANTINS",
  "PORTO NACIONAL",
  "PRAIA NORTE",
  "PRESIDENTE KENNEDY",
  "PUGMIL",
  "RECURSOLANDIA",
  "RIACHINHO",
  "RIO DA CONCEICAO",
  "RIO DOS BOIS",
  "RIO SONO",
  "SAMPAIO",
  "SANDOLANDIA",
  "SANTA FE DO ARAGUAIA",
  "SANTA MARIA DO TOCANTINS",
  "SANTA RITA DO TOCANTINS",
  "SANTA ROSA DO TOCANTINS",
  "SANTA TEREZA DO TOCANTINS",
  "SANTA TEREZINHA DO TOCANTINS",
  "SAO BENTO DO TOCANTINS",
  "SAO FELIX DO TOCANTINS",
  "SAO MIGUEL DO TOCANTINS",
  "SAO SALVADOR DO TOCANTINS",
  "SAO SEBASTIAO DO TOCANTINS",
  "SAO VALERIO DA NATIVIDADE",
  "SILVANOPOLIS",
  "SITIO NOVO DO TOCANTINS",
  "SUCUPIRA",
  "TAGUATINGA",
  "TAIPAS DO TOCANTINS",
  "TALISMA",
  "TOCANTINIA",
  "TOCANTINOPOLIS",
  "TUPIRAMA",
  "TUPIRATINS",
  "WANDERLANDIA",
  "XAMBIOA",
  "ABAETETUBA",
  "ABEL FIGUEIREDO",
  "ACARA",
  "AFUA",
  "AGUA AZUL DO NORTE",
  "ALENQUER",
  "ALMEIRIM",
  "ALTAMIRA",
  "ANAJAS",
  "ANANINDEUA",
  "ANAPU",
  "AUGUSTO CORREA",
  "AURORA DO PARA",
  "AVEIRO",
  "BAGRE",
  "BAIAO",
  "BANNACH",
  "BARCARENA",
  "BELEM",
  "BELTERRA",
  "BENEVIDES",
  "BOM JESUS DO TOCANTINS",
  "BONITO",
  "BRAGANCA",
  "BRASIL NOVO",
  "BREJO GRANDE DO ARAGUAIA",
  "BREU BRANCO",
  "BREVES",
  "BUJARU",
  "CACHOEIRA DO ARARI",
  "CACHOEIRA DO PIRIA",
  "CAMETA",
  "CANAA DOS CARAJAS",
  "CAPANEMA",
  "CAPITAO POCO",
  "CASTANHAL",
  "CHAVES",
  "COLARES",
  "CONCEICAO DO ARAGUAIA",
  "CONCORDIA DO PARA",
  "CUMARU DO NORTE",
  "CURIONOPOLIS",
  "CURRALINHO",
  "CURUA",
  "CURUCA",
  "DOM ELISEU",
  "ELDORADO DOS CARAJAS",
  "FARO",
  "FLORESTA DO ARAGUAIA",
  "GARRAFAO DO NORTE",
  "GOIANESIA DO PARA",
  "GURUPA",
  "IGARAPE-ACU",
  "IGARAPE-MIRI",
  "INHANGAPI",
  "IPIXUNA DO PARA",
  "IRITUIA",
  "ITAITUBA",
  "ITUPIRANGA",
  "JACAREACANGA",
  "JACUNDA",
  "JURUTI",
  "LIMOEIRO DO AJURU",
  "MAE DO RIO",
  "MAGALHAES BARATA",
  "MARABA",
  "MARACANA",
  "MARAPANIM",
  "MARITUBA",
  "MEDICILANDIA",
  "MELGACO",
  "MOCAJUBA",
  "MOJU",
  "MOJUI DOS CAMPOS",
  "MONTE ALEGRE",
  "MUANA",
  "NOVA ESPERANCA DO PIRIA",
  "NOVA IPIXUNA",
  "NOVA TIMBOTEUA",
  "NOVO PROGRESSO",
  "NOVO REPARTIMENTO",
  "OBIDOS",
  "OEIRAS DO PARA",
  "ORIXIMINA",
  "OUREM",
  "OURILANDIA DO NORTE",
  "PACAJA",
  "PALESTINA DO PARA",
  "PARAGOMINAS",
  "PARAUAPEBAS",
  "PAU D ARCO",
  "PEIXE-BOI",
  "PICARRA",
  "PLACAS",
  "PONTA DE PEDRAS",
  "PORTEL",
  "PORTO DE MOZ",
  "PRAINHA",
  "PRIMAVERA",
  "QUATIPURU",
  "REDENCAO",
  "RIO MARIA",
  "RONDON DO PARA",
  "RUROPOLIS",
  "SALINOPOLIS",
  "SALVATERRA",
  "SANTA BARBARA DO PARA",
  "SANTA CRUZ DO ARARI",
  "SANTA ISABEL DO PARA",
  "SANTA LUZIA DO PARA",
  "SANTA MARIA DAS BARREIRAS",
  "SANTA MARIA DO PARA",
  "SANTANA DO ARAGUAIA",
  "SANTAREM",
  "SANTAREM NOVO",
  "SANTO ANTONIO DO TAUA",
  "SAO CAETANO DE ODIVELAS",
  "SAO DOMINGOS DO ARAGUAIA",
  "SAO DOMINGOS DO CAPIM",
  "SAO FELIX DO XINGU",
  "SAO FRANCISCO DO PARA",
  "SAO GERALDO DO ARAGUAIA",
  "SAO JOAO DA PONTA",
  "SAO JOAO DE PIRABAS",
  "SAO JOAO DO ARAGUAIA",
  "SAO MIGUEL DO GUAMA",
  "SAO SEBASTIAO DA BOA VISTA",
  "SAPUCAIA",
  "SENADOR JOSE PORFIRIO",
  "SOURE",
  "TAILANDIA",
  "TERRA ALTA",
  "TERRA SANTA",
  "TOME-ACU",
  "TRACUATEUA",
  "TRAIRAO",
  "TUCUMA",
  "TUCURUI",
  "ULIANOPOLIS",
  "URUARA",
  "VIGIA",
  "VISEU",
  "VITORIA DO XINGU",
  "XINGUARA",
  "ALTA FLORESTA D OESTE",
  "ALTO ALEGRE DOS PARECIS",
  "ALTO PARAISO",
  "ALVORADA D OESTE",
  "ARIQUEMES",
  "BURITIS",
  "CABIXI",
  "CACAULANDIA",
  "CACOAL",
  "CAMPO NOVO DE RONDONIA",
  "CANDEIAS DO JAMARI",
  "CASTANHEIRAS",
  "CEREJEIRAS",
  "CHUPINGUAIA",
  "COLORADO DO OESTE",
  "CORUMBIARA",
  "COSTA MARQUES",
  "CUJUBIM",
  "ESPIGAO D OESTE",
  "GOVERNADOR JORGE TEIXEIRA",
  "GUAJARA-MIRIM",
  "ITAPUA D OESTE",
  "JARU",
  "JI-PARANA",
  "MACHADINHO D OESTE",
  "MINISTRO ANDREAZZA",
  "MIRANTE DA SERRA",
  "MONTE NEGRO",
  "NOVA BRASILANDIA D OESTE",
  "NOVA MAMORE",
  "NOVA UNIAO",
  "NOVO HORIZONTE DO OESTE",
  "OURO PRETO DO OESTE",
  "PARECIS",
  "PIMENTA BUENO",
  "PIMENTEIRAS D OESTE",
  "PORTO VELHO",
  "PRESIDENTE MEDICI",
  "PRIMAVERA DE RONDONIA",
  "RIO CRESPO",
  "ROLIM DE MOURA",
  "SANTA LUZIA D OESTE",
  "SAO FELIPE D OESTE",
  "SAO FRANCISCO DO GUAPORE",
  "SAO MIGUEL DO GUAPORE",
  "SERINGUEIRAS",
  "TEIXEIROPOLIS",
  "THEOBROMA",
  "URUPA",
  "VALE DO ANARI",
  "VALE DO PARAISO",
  "VILHENA",
  "AGUA BRANCA",
  "AGUIAR",
  "ALAGOA GRANDE",
  "ALAGOA NOVA",
  "ALAGOINHA",
  "ALCANTIL",
  "ALGODAO DE JANDAIRA",
  "ALHANDRA",
  "AMPARO",
  "APARECIDA",
  "ARACAGI",
  "ARARA",
  "ARARUNA",
  "AREIA",
  "AREIA DE BARAUNAS",
  "AREIAL",
  "AROEIRAS",
  "ASSUNCAO",
  "BAIA DA TRAICAO",
  "BANANEIRAS",
  "BARAUNA",
  "BARRA DE SANTA ROSA",
  "BARRA DE SANTANA",
  "BARRA DE SAO MIGUEL",
  "BAYEUX",
  "BELEM",
  "BELEM DO BREJO DO CRUZ",
  "BERNARDINO BATISTA",
  "BOA VENTURA",
  "BOA VISTA",
  "BOM JESUS",
  "BOM SUCESSO",
  "BONITO DE SANTA FE",
  "BOQUEIRAO",
  "BORBOREMA",
  "BREJO DO CRUZ",
  "BREJO DOS SANTOS",
  "CAAPORA",
  "CABACEIRAS",
  "CABEDELO",
  "CACHOEIRA DOS INDIOS",
  "CACIMBA DE AREIA",
  "CACIMBA DE DENTRO",
  "CACIMBAS",
  "CAICARA",
  "CAJAZEIRAS",
  "CAJAZEIRINHAS",
  "CALDAS BRANDAO",
  "CAMALAU",
  "CAMPINA GRANDE",
  "CAMPO DE SANTANA",
  "CAPIM",
  "CARAUBAS",
  "CARRAPATEIRA",
  "CASSERENGUE",
  "CATINGUEIRA",
  "CATOLE DO ROCHA",
  "CATURITE",
  "CONCEICAO",
  "CONDADO",
  "CONDE",
  "CONGO",
  "COREMAS",
  "COXIXOLA",
  "CRUZ DO ESPIRITO SANTO",
  "CUBATI",
  "CUITE",
  "CUITE DE MAMANGUAPE",
  "CUITEGI",
  "CURRAL DE CIMA",
  "CURRAL VELHO",
  "DAMIAO",
  "DESTERRO",
  "DIAMANTE",
  "DONA INES",
  "DUAS ESTRADAS",
  "EMAS",
  "ESPERANCA",
  "FAGUNDES",
  "FREI MARTINHO",
  "GADO BRAVO",
  "GUARABIRA",
  "GURINHEM",
  "GURJAO",
  "IBIARA",
  "IGARACY",
  "IMACULADA",
  "INGA",
  "ITABAIANA",
  "ITAPORANGA",
  "ITAPOROROCA",
  "ITATUBA",
  "JACARAU",
  "JERICO",
  "JOAO PESSOA",
  "JUAREZ TAVORA",
  "JUAZEIRINHO",
  "JUNCO DO SERIDO",
  "JURIPIRANGA",
  "JURU",
  "LAGOA",
  "LAGOA DE DENTRO",
  "LAGOA SECA",
  "LASTRO",
  "LIVRAMENTO",
  "LOGRADOURO",
  "LUCENA",
  "MAE D AGUA",
  "MALTA",
  "MAMANGUAPE",
  "MANAIRA",
  "MARCACAO",
  "MARI",
  "MARIZOPOLIS",
  "MASSARANDUBA",
  "MATARACA",
  "MATINHAS",
  "MATO GROSSO",
  "MATUREIA",
  "MOGEIRO",
  "MONTADAS",
  "MONTE HOREBE",
  "MONTEIRO",
  "MULUNGU",
  "NATUBA",
  "NAZAREZINHO",
  "NOVA FLORESTA",
  "NOVA OLINDA",
  "NOVA PALMEIRA",
  "OLHO D AGUA",
  "OLIVEDOS",
  "OURO VELHO",
  "PARARI",
  "PASSAGEM",
  "PATOS",
  "PAULISTA",
  "PEDRA BRANCA",
  "PEDRA LAVRADA",
  "PEDRAS DE FOGO",
  "PEDRO REGIS",
  "PIANCO",
  "PICUI",
  "PILAR",
  "PILOES",
  "PILOEZINHOS",
  "PIRPIRITUBA",
  "PITIMBU",
  "POCINHOS",
  "POCO DANTAS",
  "POCO DE JOSE DE MOURA",
  "POMBAL",
  "PRATA",
  "PRINCESA ISABEL",
  "PUXINANA",
  "QUEIMADAS",
  "QUIXABA",
  "REMIGIO",
  "RIACHAO",
  "RIACHAO DO BACAMARTE",
  "RIACHAO DO POCO",
  "RIACHO DE SANTO ANTONIO",
  "RIACHO DOS CAVALOS",
  "RIO TINTO",
  "SALGADINHO",
  "SALGADO DE SAO FELIX",
  "SANTA CECILIA",
  "SANTA CRUZ",
  "SANTA HELENA",
  "SANTA INES",
  "SANTA LUZIA",
  "SANTA RITA",
  "SANTA TERESINHA",
  "SANTANA DE MANGUEIRA",
  "SANTANA DOS GARROTES",
  "SANTAREM",
  "SANTO ANDRE",
  "SAO BENTINHO",
  "SAO BENTO",
  "SAO DOMINGOS DE POMBAL",
  "SAO DOMINGOS DO CARIRI",
  "SAO FRANCISCO",
  "SAO JOAO DO CARIRI",
  "SAO JOAO DO RIO DO PEIXE",
  "SAO JOAO DO TIGRE",
  "SAO JOSE DA LAGOA TAPADA",
  "SAO JOSE DE CAIANA",
  "SAO JOSE DE ESPINHARAS",
  "SAO JOSE DE PIRANHAS",
  "SAO JOSE DE PRINCESA",
  "SAO JOSE DO BONFIM",
  "SAO JOSE DO BREJO DO CRUZ",
  "SAO JOSE DO SABUGI",
  "SAO JOSE DOS CORDEIROS",
  "SAO JOSE DOS RAMOS",
  "SAO MAMEDE",
  "SAO MIGUEL DE TAIPU",
  "SAO SEBASTIAO DE LAGOA DE ROCA",
  "SAO SEBASTIAO DO UMBUZEIRO",
  "SAO VICENTE DO SERIDO",
  "SAPE",
  "SERRA BRANCA",
  "SERRA DA RAIZ",
  "SERRA GRANDE",
  "SERRA REDONDA",
  "SERRARIA",
  "SERTAOZINHO",
  "SOBRADO",
  "SOLANEA",
  "SOLEDADE",
  "SOSSEGO",
  "SOUSA",
  "SUME",
  "TAPEROA",
  "TAVARES",
  "TEIXEIRA",
  "TENORIO",
  "TRIUNFO",
  "UIRAUNA",
  "UMBUZEIRO",
  "VARZEA",
  "VIEIROPOLIS",
  "VISTA SERRANA",
  "ZABELE"
]



// WEBPACK FOOTER //
// ./src/services/state/customer/constants.js